
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses/online-ad-creatives",
      function () {
        return require("private-next-pages/for-businesses/online-ad-creatives/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses/online-ad-creatives"])
      });
    }
  